export default function getHash( str ) {
	/* let res = 0
	const len = str.length
	for ( let i = 0; i < len; i++ ) {
		res = res * 31 + str.charCodeAt( i )
	}
	return res */

	// https://stackoverflow.com/questions/7616461/generate-a-hash-from-string-in-javascript-jquery
	return str.split('').reduce((prevHash, currVal) =>
    (((prevHash << 5) - prevHash) + currVal.charCodeAt(0))|0, 0);
}



// WEBPACK FOOTER //
// ./dev/stylist_parent/functions/get-hash.js